import { Checkout, ConsumerLookup } from '@afterpaytouch/portal-api/types'
import { CrossRegionRedirection } from '../../../model'
import { TrackingEvent } from '../../../model/monitoring'
import { determineRouteFromConsumerLookup, InitialiseNextRoute } from '../routing'
import { CheckoutAppDispatch } from '../../../state'
import { Route } from '../../../config/router'
import { deriveHasCashtag } from '../../../state/convergence/helper'

export interface ConsumerLookupRequest {
  checkout: Checkout
  consumerLookup: ConsumerLookup
  logEvent: (event: string, data?: Record<string, unknown>) => void
  cashAuthRoute: Route
}

export const handleConsolidatedConsumerLookup = (
  request: ConsumerLookupRequest,
  dispatch: CheckoutAppDispatch
): InitialiseNextRoute | CrossRegionRedirection => {
  const { checkout, consumerLookup, logEvent, cashAuthRoute } = request
  const hasCashtag = deriveHasCashtag(consumerLookup) === true

  logEvent(TrackingEvent.GET_CHECKOUT_RETURN_LOOKUP_DATA, {
    cohort: consumerLookup.cohort,
    action: consumerLookup.action,
    hasCashtag,
    countryCode: consumerLookup.countryCode,
    redirectUrl: consumerLookup.redirectUrl,
    recognizedBy: consumerLookup.recognizedBy,
  })

  return determineRouteFromConsumerLookup(checkout.merchant.id, consumerLookup, hasCashtag, dispatch, cashAuthRoute)
}
